<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M32 52.0364L12.2229 62.4338L16 40.4117L0 24.8155L22.1114 21.6026L32 1.56618L41.8885 21.6026L64 24.8155L48 40.4117L51.7771 62.4338L32 52.0364Z"
  />
</template>
